import api from './api';

export async function validateCreatorCode(code) {
  const response = await api.get(`/creator/validate/${encodeURIComponent(code)}`);
  if (response.data.error !== undefined) throw new Error(response.data.error);
  return response.data.result;
}

export async function getCreatorDashboard() {
  const response = await api.get('/creator/dashboard');
  if (response.data.error !== undefined) throw new Error(response.data.error);
  return response.data.result;
}

export async function searchAccounts(query) {
  const response = await api.get(`/staff/creator/search-accounts?q=${encodeURIComponent(query)}`);
  if (response.data.error !== undefined) throw new Error(response.data.error);
  return response.data.result;
}

export async function getStaffCreatorList() {
  const response = await api.get('/staff/creator/list');
  if (response.data.error !== undefined) throw new Error(response.data.error);
  return response.data.result;
}

export async function getStaffCreatorSummary() {
  const response = await api.get('/staff/creator/summary');
  if (response.data.error !== undefined) throw new Error(response.data.error);
  return response.data.result;
}

export async function getStaffCreatorTransactions(creatorId) {
  const response = await api.get(`/staff/creator/${creatorId}/transactions`);
  if (response.data.error !== undefined) throw new Error(response.data.error);
  return response.data.result;
}

export async function createCreator(accountId, code, revenuePct, minCoins) {
  const response = await api.post('/staff/creator/create', { accountId, code, revenuePct, minCoins });
  if (response.data.error !== undefined) throw new Error(response.data.error);
  return response.data.result;
}

export async function updateCreator(creatorId, code, revenuePct, minCoins, enabled) {
  const response = await api.put('/staff/creator/update', { creatorId, code, revenuePct, minCoins, enabled });
  if (response.data.error !== undefined) throw new Error(response.data.error);
  return response.data.result;
}

export async function payoutTransactions(transactionIds, payoutRefId) {
  const response = await api.post('/staff/creator/payout', { transactionIds, payoutRefId });
  if (response.data.error !== undefined) throw new Error(response.data.error);
  return response.data.result;
}

export async function releaseTransaction(transactionId) {
  const response = await api.post('/staff/creator/release', { transactionId });
  if (response.data.error !== undefined) throw new Error(response.data.error);
  return response.data.result;
}

export async function rejectTransaction(transactionId) {
  const response = await api.post('/staff/creator/reject', { transactionId });
  if (response.data.error !== undefined) throw new Error(response.data.error);
  return response.data.result;
}
